<div class="lum-chip__wrapper">
  <button class="lum-chip__label p-1-5" [ngClass]="cssClasses">
    {{ label }}
  </button>
</div>
